import actions from './actions'

const initialState = {
  pagination: {
    skip: 0,
    limit: 10,
  },
  companyProfileData: {},
  totalCount: 0,
  isLoading: false,
}

const companyProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.COMPANY_PROFILE_SET_STATE:
      return {
        ...state,
        ...action.payload,
      }
    case actions.COMPANY_PROFILE_DETAILS:
      return {
        ...state,
        companyProfileData: action.payload?.companyProfile?.[0] || {},
        totalCount: action.payload?.totalCount || 0,
      }
    default:
      return state
  }
}

export default companyProfileReducer
